<template>
  <div>
  <!--登录组件-->
  <a-modal :visible="loginShow" width="350px" @cancel="loginCancel">
    <!--      微信登录页面-->
    <div v-show="loginDisplay === 'weixin'">
      <div class="login-wx">
        <div class="login-wx-header">
                     <p style="font-size: 15px"><b>微信扫码登录</b></p>
          <!-- <p style="color: #adadad">同时支持企业微信和微信扫码</p> -->
          <!-- <p style="color: #adadad">企业微信</p> -->
        </div>
        <div class="login-wx-body">
          <div id="weixin"></div>
        </div>
      </div>
    </div>

    <!--      账号密码登录页面-->
    <div v-show="loginDisplay === 'account'">
      <div class="login-wx">
        <div class="login-wx-header">
          <p style="font-size: 15px"><b>账号密码登录</b></p>
        </div>
        <div class="login-account-body">
          <a-form-model
            :model="accountFormModel"
            style="
              width: 100%;
              height: 180px;
              display: flex;
              align-content: space-around;
              flex-wrap: wrap;
            "
            :rules="rule"
            ref="accountFormModel"
          >
            <a-form-model-item prop="username" style="width: 100%">
              <a-input
                v-model="accountFormModel.username"
                placeholder="请输入手机号"
                size="large"
                style="font-size: 13px"
              />
            </a-form-model-item>
            <a-form-model-item style="width: 100%" prop="password">
              <a-input-password
                v-model="accountFormModel.password"
                placeholder="输入登录密码"
                size="large"
              />
            </a-form-model-item>
            <a-form-model-item
              style="width: 100%; margin-top: -20px"
              prop="icu_checkBox"
            >
              <div style="display: flex; justify-content: space-between">
                <span>
                  <a-checkbox v-model="accountFormModel.icu_checkBox"
                    >我同意</a-checkbox
                  >
                  <a
                    href="https://yunicu-mp.yunicu.com/agreement?domain_code=yunicu"
                    target="_blank"
                    >云ICU用户协议</a
                  >
                </span>
                <span
                  style="cursor: pointer"
                  @click="
                    () => {
                      this.$router.push({ name: 'UpdatePwd' });
                    }
                  "
                >
                  忘记密码
                </span>
              </div>
            </a-form-model-item>
          </a-form-model>
          <a-button
            type="primary"
            size="large"
            style="width: 100%"
            @click="accountLogin"
            >登录</a-button
          >
        </div>
      </div>
    </div>

    <!--      验证码登录-->
    <div v-show="loginDisplay === 'code'">
      <div class="login-wx">
        <div class="login-wx-header">
          <p style="font-size: 15px"><b>验证码登录</b></p>
        </div>

        <div class="login-account-body">
          <a-form-model
            :model="codeFormModel"
            style="
              width: 100%;
              height: 180px;
              display: flex;
              align-content: space-around;
              flex-wrap: wrap;
            "
            :rules="codeRule"
            ref="codeFormModel"
          >
            <a-form-model-item prop="phone" style="width: 100%">
              <a-input
                v-model="codeFormModel.phone"
                placeholder="请输入手机号"
                size="large"
                style="font-size: 13px"
              />
            </a-form-model-item>
            <a-form-model-item style="width: 100%" prop="code">
              <a-input
                v-model="codeFormModel.code"
                placeholder="输入验证码"
                size="large"
              >
                <a-tooltip slot="suffix">
                  <a-button
                    size="small"
                    type="primary"
                    @click="phoneLogin"
                    :disabled="phoneCodeLoginDisabled"
                    >{{ phoneCodeLoginText }}</a-button
                  >
                </a-tooltip>
              </a-input>
            </a-form-model-item>
            <a-form-model-item
              style="width: 100%; margin-top: -20px"
              prop="icu_checkBox"
            >
              <span>
                <a-checkbox v-model="codeFormModel.icu_checkBox"
                  >我同意</a-checkbox
                >
                <a
                  href="https://yunicu-mp.yunicu.com/agreement?domain_code=yunicu"
                  target="_blank"
                  >云ICU用户协议</a
                >
              </span>
            </a-form-model-item>
          </a-form-model>
          <a-button
            size="large"
            style="width: 100%"
            type="primary"
            @click="phoneCodeLoginSubmit"
            >登录</a-button
          >
        </div>
      </div>
    </div>

    <template slot="footer">
      <div
        v-show="loginDisplay === 'weixin'"
        style="display: flex; justify-content: space-between"
      >
        <span class="login-footer" @click="loginSwitch('account')"
          >账号密码登录</span
        >
        <span class="login-footer" @click="loginSwitch('code')"
          >验证码登录</span
        >
      </div>
      <div
        v-show="loginDisplay === 'account'"
        style="display: flex; justify-content: space-between"
      >
                  <span class="login-footer" @click="loginSwitch('weixin')">微信登录</span>
        <span class="login-footer" @click="loginSwitch('code')"
          >验证码登录</span
        >
        <!-- <span class="login-footer" style="color:#fff" @click="loginSwitch('weixin')">微信登录</span> -->
      </div>
      
      <div
        v-show="loginDisplay === 'code'"
        style="display: flex; justify-content: space-between"
      >
                 <span class="login-footer" @click="loginSwitch('weixin')">微信登录</span>
        <span class="login-footer" @click="loginSwitch('account')"
          >账号密码登录</span
        >
        <!-- <span class="login-footer" style="color:#fff" @click="loginSwitch('weixin')">微信登录</span> -->
      </div>
    </template>
  </a-modal>

  <a-modal :visible="wxShow" width="350px" :footer="null" @cancel="wxCancel">
    <div>
      <div class="login-wx">
        <div class="login-wx-header">
          <p style="font-size: 15px"><b>绑定手机号</b></p>
        </div>

        <div class="login-account-body">
          <a-form-model
            :model="wxFormModel"
            style="
              width: 100%;
              height: 180px;
              display: flex;
              align-content: space-around;
              flex-wrap: wrap;
            "
            :rules="codeRule"
            ref="wxFormModel"
          >
            <a-form-model-item prop="phone" style="width: 100%">
              <a-input
                v-model="wxFormModel.phone"
                placeholder="请输入手机号"
                size="large"
                style="font-size: 13px"
              />
            </a-form-model-item>
            <a-form-model-item style="width: 100%" prop="code">
              <a-input
                v-model="wxFormModel.code"
                placeholder="输入验证码"
                size="large"
              >
                <a-tooltip slot="suffix">
                  <a-button
                    size="small"
                    type="primary"
                    @click="wxBinding"
                    :disabled="phoneCodeLoginDisabled"
                    >{{ phoneCodeLoginText }}</a-button
                  >
                </a-tooltip>
              </a-input>
            </a-form-model-item>
            <a-form-model-item
              style="width: 100%; margin-top: -20px"
              prop="icu_checkBox"
            >
              <span>
                <a-checkbox v-model="wxFormModel.icu_checkBox"
                  >我同意</a-checkbox
                >
                <a
                  href="https://yunicu-mp.yunicu.com/agreement?domain_code=yunicu"
                  target="_blank"
                  >云ICU用户协议</a
                >
              </span>
            </a-form-model-item>
          </a-form-model>
          <a-button
            size="large"
            style="width: 100%"
            type="primary"
            @click="wxLoginSubmit"
            >提交</a-button
          >
        </div>
      </div>
    </div>
  </a-modal>

  <!-- <div id="captcha"></div> -->
  </div>

</template>

<script>
import {
  getPersonalData,
  postLoginPhoneCode,
  postLoginPhoneCodeSubmit,
  postUserNamePasswordLogin,
  postwxCodeSubmit,
  getWechatLogin,
  postTianyu
} from "@/service/api_fire";
import { getAdmins } from "@/util/adminDate";
import { addUserInfo, getUserInfo } from "@/util/userInfo";
export default {
  name: "login",

  props: {
    loginVisible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const phoneValid = (rule, value, callback) => {
      // 自定义校验规则-手机号
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号码格式"));
      } else {
        callback();
      }
    };
    const icu_check = (rule, value, callback) => {
      // 自定义校验规则-是否点击用户协议
      if (value) {
        callback();
      } else {
        callback(new Error("请阅读并同意用户协议"));
      }
    };
    return {
      captcha: null,
      wxFormModel: {
        icu_checkBox: false,
      },
      unionId:'',
      wxShow:false,
      loginShow: false,
      //是否点击同意云ICU用户协议
      icu_checkBox: false,
      avatar: this.$store.state.avatar,
      moRenUrl: require("/src/assets/默认头像.png"),
      //用户登录token
       token: window.localStorage.getItem("user_info")?JSON.parse(window.localStorage.getItem("user_info")).id:'',
      //微信登录二维码
      wxLoginImg: "",
      //登录窗口控制
      // loginVisible: false,
      //手机号登录
      accountVisible: false,
      //验证码登录
      verificationVisible: false,
      //微信扫码
      WeChatVisible: false,
      //验证身份
      statusVisible: false,
      accountForm: {
        tel: "",
        password: "",
        radioValue: "",
      },
      verificationForm: {
        tel: "",
        password: "",
        radioValue: "",
      },
      loginDisplay: "code",
      accountFormModel: {
        icu_checkBox: false,
      },
      rule: {
        username: {
          required: true,
          validator: phoneValid,
          whitespace: true,
          trigger: "blur",
        },
        password: {
          required: true,
          message: "请输入密码",
          whitespace: true,
          trigger: "blur",
        },
        icu_checkBox: {
          required: true,
          validator: icu_check,
          whitespace: true,
          trigger: "change",
        },
      },
      codeRule: {
        phone: {
          required: true,
          validator: phoneValid,
          whitespace: true,
          trigger: "change",
        },
        code: {
          required: true,
          message: "请输入验证码",
          whitespace: true,
          trigger: "change",
        },
        icu_checkBox: {
          required: true,
          validator: icu_check,
          whitespace: true,
          trigger: "change",
        },
      },
      codeFormModel: {
        icu_checkBox: false,
      },
      phoneCodeLoginText: "获取验证码",
      phoneCodeLoginDisabled: false,
    };
  },
  watch: {
    loginVisible(newValue, oldValue) {
      this.loginShow = newValue;
      if (newValue === true) {
        this.$nextTick(() => {
          new WxLogin({
            self_redirect: false,
            id: "weixin",

            appid: "wx02d7d0387ff1b54c", // 这个appid要填死

            scope: "snsapi_login",

            // 扫码成功后重定向的接口

            redirect_uri: "http://yunicu.com",
            // redirect_uri: "http://192.168.5.115:8080",

            // state填写编码后的url

            state: Math.ceil(Math.random() * 1000),

            // 调用样式文件

            href: "data:text/css;base64,Lyogd3hsb2dpbi5jc3MgKi8KLmltcG93ZXJCb3ggLnRpdGxlLCAuaW1wb3dlckJveCAuaW5mb3sKICBkaXNwbGF5OiBub25lOwp9CgouaW1wb3dlckJveCAucXJjb2RlewogIG1hcmdpbi10b3A6IDIwcHg7CiAgd2lkdGg6IDE5MHB4Owp9",
          });
        });
      }
    },
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      // let { name, avatar } = getUserInfo("name,avatar");
      this.name = window.localStorage.getItem("user_info")?JSON.parse(window.localStorage.getItem("user_info")).name:'';
      // this.avatar = this.$store.state.avatar;
      // if (this.avatar) this.avatar = avatar;
    });
    setTimeout(() => {
      this.avatar = this.$store.state.avatar;
    }, 300);
    this.$nextTick(() => {
      // 检查 URL 中是否有微信授权码
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      if (code) {
        this.handleWechatLogin(code);
      }
    });
  },
  methods: {
    loginSwitch(type) {
      // 用户登录界面切换
      this.loginDisplay = type;
    },
    async handleWechatLogin(code) {
      try {
        // 调用微信登录接口，传入授权码
        const response = await getWechatLogin(code);
        // console.log("微信授权码:", response); 
        if (response.code === 0) {
          // 登录成功
          this.$message.success("微信登录成功");
          window.localStorage.setItem("user_info", JSON.stringify(response.data.member));
          window.location.reload();
        } else if(response.code === -1) {
          // 登录失败
          // this.$message.warn(response.message);
          // 关闭上一个弹窗
          this.loginShow = false
          this.wxShow = true
          this.unionId = response.data.unionId
        }
      } catch (error) {
        // console.error('微信登录出错:', error);
        this.$message.error('微信登录出错，请稍后重试');
      }
      // console.log("登录成功",code)
    },
    loginCancel() {
      this.$emit("loginCancel");
      // this.loginVisible = false
    },
    wxCancel() {
      // this.$emit("loginCancel");
      this.wxShow = false
    },
    accountLogin() {
      //账号密码登录方法
      this.$refs.accountFormModel.validate(async (valid) => {
        if (valid) {
          let dataPhone = {
            tel: this.accountFormModel.username,
            password: this.accountFormModel.password,
          };
          const response = await postUserNamePasswordLogin(dataPhone);

          if (response.code === 0) {
            // 登录成功
            this.$message.success("登录成功");
            // let data1 = {
            //   token: "",
            //   avatar: response.data.avatar,
            //   user_id:response.data

            // };
            this.$store.state.avatar = response.data.avatar;
            //  window.localStorage.setItem("user_info",  response.data)
            // addUserInfo("user_info",  data1); // 调用方法将用户数据添加到本地
            window.localStorage.setItem(
              "user_info",
              JSON.stringify(response.data)
            );
            // this.$store.commit("getUserData");

            // setTimeout(() => {
            window.location.reload();
            // }, 300);
          } else {
            // 登陆失败
            this.$message.warn(response.message);
          }
        }
      });
    },
    // 1.手机登录 -- 弹出图形验证码
    async phoneLogin() {
      this.$refs.codeFormModel.validate(async (valid, type) => {
        if (!type.phone) {
          let appid = '196644000';
		    	// 创建TencenCaptcha实例
		    	let captcha = new TencentCaptcha(appid, (res) => {
		    		// res（用户滑动验证成功）= {ret: 0, ticket: "String", randstr: "String"}
		    		if (res.ret === 0) {
              // console.log("滑动成功",res)
              this.getCaptcha(res,'phone')
		    			// 滑动验证成功后，给后端发送数据，CaptchaAppld可以不传
              // name和password 根据需求和逻辑传
              // Ticket是必须的票据，大概长这样WrBrJkE7Ohu_vMdXKUBx3O7Pn9kHbG6Nv7WfUr6P
              // Randstr是必须的前端回调函数返回的随机字符串，大概长这样“@tpR”
		    		} else {
  		        // res（用户主动关闭验证码）= {ret: 2, ticket: null}
		    		}
		    	});
		    	// 显示验证码
		    	captcha.show();
        } else {
          this.$message.warning("请填写手机号码");
        }

      });
		},
    // 2.图形验证码接口
    async getCaptcha(data,type) {
      let info = {
        ticket:data.ticket,
        randstr:data.randstr
      }
      const response = await postTianyu(info);
      if (response.code === 0) {
        // this.$message.success("发送成功");
        // this.phoneCodeLogin60s(); // 调用验证码倒计时
        if(type == 'phone') {
          this.getPhoneCode() 
        }else{
          this.wxCodeLogin()
        }
      } else {
        this.$message.warning(response.message);
      }
    },
    // 3.手机验证码登录-获取验证码
    async getPhoneCode() {
      const response = await postLoginPhoneCode(
        this.codeFormModel.phone,
        "yunicu"
      );
      if (response.code === 0) {
        this.$message.success("发送成功");
        this.phoneCodeLogin60s(); // 调用验证码倒计时
      } else {
        this.$message.warning(response.message);
      }
    },
    // 4.手机验证码登录-提交
    phoneCodeLoginSubmit() {
      //手机验证码登录提交
      this.$refs.codeFormModel.validate(async (valid) => {
        if (valid) {
          let codeData = {
            tel: this.codeFormModel.phone,
            sms: this.codeFormModel.code,
          };
          const response = await postLoginPhoneCodeSubmit("yunicu", codeData);
          if (response.code === 0) {
            window.localStorage.setItem("user_info",JSON.stringify(response.data));
            //  this.$store.commit("getUserData");
             this.$message.success("登录成功");
            // setTimeout(() => {
            window.location.reload();
            // }, 300);
          } else {
            this.$message.warning(response.message);
          }
        }
      });
    },

    // 微信登录绑定手机号 -- 弹出图形验证码
    async wxBinding() {
      this.$refs.wxFormModel.validate(async (valid, type) => {
        if (!type.phone) {
          let appid = '196644000';
		    	// 创建TencenCaptcha实例
		    	let captcha = new TencentCaptcha(appid, (res) => {
		    		// res（用户滑动验证成功）= {ret: 0, ticket: "String", randstr: "String"}
		    		if (res.ret === 0) {
              this.getCaptcha(res,'wx')
		    		} else {
  		        // res（用户主动关闭验证码）= {ret: 2, ticket: null}
		    		}
		    	});
		    	// 显示验证码
		    	captcha.show();
        } else {
          this.$message.warning("请填写手机号码");
        }

      });
		},
    async wxCodeLogin() {
      //验证码登录-获取验证码
      const response = await postLoginPhoneCode(
        this.wxFormModel.phone,
        "yunicu"
      );
      if (response.code === 0) {
        this.$message.success("发送成功");
        this.phoneCodeLogin60s(); // 调用验证码倒计时
      } else {
        this.$message.warning(response.message);
      }
    },
    wxLoginSubmit() {
      //微信绑定手机号提交
      this.$refs.wxFormModel.validate(async (valid) => {
        if (valid) {
          let codeData = {
            tel: this.wxFormModel.phone,
            sms: this.wxFormModel.code,
            // "union_open_id":"",//可选，用来绑定app微信
            unionid:this.unionId//可选，用来绑定app微信
          };
          const response = await postwxCodeSubmit("yunicu",1,codeData);
          if (response.code === 0) {
            window.localStorage.setItem("user_info",JSON.stringify(response.data));
            //  this.$store.commit("getUserData");
             this.$message.success("登录成功");
            // setTimeout(() => {
            window.location.reload();
            this.wxShow = false
            // }, 300);
          } else {
            this.$message.warning(response.message);
          }
        }
      });
    },
    
    phoneCodeLogin60s() {
      // 验证码登录-获取验证码-60s倒计时
      this.phoneCodeLoginDisabled = true;
      let count = 60;
      let interval = setInterval(() => {
        count--;
        this.phoneCodeLoginText = count + "s";

        if (count === 0) {
          clearInterval(interval);
          this.phoneCodeLoginText = "重新获取";
          this.phoneCodeLoginDisabled = false;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-login {
  width: 100%;
  height: auto;
  margin: auto;
  padding-top: 30px;

  .banner-login-font {
    color: #333333;
    font-size: 16px;
    width: 100%;
    text-align: center;
    margin-bottom: 30px;
  }

  .banner-login-tel {
    height: 40px;
  }

  .banner-login-pass {
    height: 40px;
  }

  .banner-login-tel-input {
    width: 100%;
    height: 40px;
  }

  .banner-radio {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .banner-button {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }

  .banner-forget {
    width: 320px;
    text-align: right;
    margin-top: 10px;
  }

  .banner-other {
    width: 320px;
    display: flex;
    margin-bottom: 30px;

    .banner-other-left {
      width: 33%;
      height: 1px;
      background-color: #d3d2d2;
      margin-top: 10px;
    }

    .banner-other-font {
      width: 33%;
      font-size: 12px;
      color: #9b9b9b;
      margin-left: 10px;
      margin-right: 10px;
      text-align: center;
    }
  }

  .banner-icon {
    width: 100%;
    display: flex;
    height: 50px;
    border-top: 1px solid #9b9b9b;
    background-color: #fff;

    .banner-icon-left {
      width: 50px;
      margin: auto;

      .imgL {
        width: 50px;
        text-align: center;
        font-size: 12px;
        margin-top: 5px;
        cursor: pointer;
      }

      .icon-img {
        width: 50px;
        height: 50px;
        cursor: pointer;
      }
    }
  }
}

.banner-verification {
  width: 100%;
  height: auto;
  margin: auto;
  padding-top: 30px;

  .banner-login-font {
    color: #333333;
    font-size: 16px;
    width: 100%;
    text-align: center;
    margin-bottom: 30px;
  }

  .banner-login-tel {
    height: 40px;
  }

  .banner-login-pass {
    height: 40px;
  }

  .banner-login-tel-input {
    width: 100%;
    height: 40px;
  }

  .banner-radio {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .banner-button {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }

  .banner-forget {
    width: 320px;
    text-align: right;
    margin-top: 10px;
  }

  .banner-other {
    width: 320px;
    display: flex;
    margin-bottom: 30px;

    .banner-other-left {
      width: 33%;
      height: 1px;
      background-color: #d3d2d2;
      margin-top: 10px;
    }

    .banner-other-font {
      width: 33%;
      font-size: 12px;
      color: #9b9b9b;
      margin-left: 10px;
      margin-right: 10px;
      text-align: center;
    }
  }

  .banner-icon {
    width: 320px;
    display: flex;

    .banner-icon-left {
      width: 50px;
      margin: auto;

      .imgL {
        width: 50px;
        text-align: center;
        font-size: 12px;
        margin-top: 5px;
        cursor: pointer;
      }

      .icon-img {
        width: 50px;
        height: 50px;
        cursor: pointer;
      }
    }
  }
}

.banner-WeChat {
  width: 100%;
  height: auto;
  margin: auto;
  padding-top: 30px;

  .banner-login-font {
    color: #333333;
    font-size: 16px;
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }

  .banner-login-fontTwo {
    font-size: 14px;
    color: #999999;
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }

  .banner-code {
    width: 250px;
    height: 250px;
    margin: auto;
    border: 1px solid #d3d1d1;
  }

  .banner-icon {
    width: 320px;
    display: flex;

    .banner-icon-left {
      width: 50px;
      margin: auto;

      .imgL {
        width: 50px;
        text-align: center;
        font-size: 12px;
        margin-top: 5px;
        cursor: pointer;
      }

      .icon-img {
        width: 50px;
        height: 50px;
        cursor: pointer;
      }
    }
  }
}

.banner-status {
  width: 320px;
  height: 500px;
  margin: auto;
  padding-top: 30px;

  .banner-login-font {
    color: #333333;
    font-size: 20px;
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }

  .banner-select {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #d1e3fc;
    text-align: center;
    margin-bottom: 10px;
  }
}

.footer-font {
  width: 50%;
  text-align: center;
  color: black;
  cursor: pointer;
}

.login-wx {
  width: 100%;
  height: 100%;
  margin-top: 10px;
}

.login-wx-header {
  width: 100%;
  text-align: center;
}

.login-wx-body {
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: space-evenly;
}

.login {
  margin-left: 15px;
  cursor: pointer;
}

.login > a {
  margin-left: 2px;
  color: #000000a6;
}

.login:hover > a {
  color: #1890ff;
}

#weixin {
  height: 250px;
}

.login-footer {
  padding: 5px;
}

.login-footer:hover {
  cursor: pointer;
  color: #1890ff;
}

.login-account-body {
  width: 100%;
  height: 100%;
}
::v-deep .ant-input-lg {
  font-size: 13px;
  width: 100%;
}
</style>
